<ng-container *ngFor="let currentQuestion of currentQuestion">
    <div class="border border-secondary rounded p-2 mb-2 border-opacity-50 radius-2"
      *ngIf="currentQuestion"
      [ngSwitch]="currentQuestion.type"
    >
      <!-- content 2 -->
      <div class="flex-column 11111" *ngSwitchCase="'EMAIL_ADDRESS'">
        <div class="">
          <div
            class="flex-column"
            *ngFor="let field of currentQuestion.meta.fields"
          >
            <div class="flex-column">
              <label
                class="description"
                *ngIf="currentQuestion.meta.description"
                [innerHTML]="currentQuestion.meta.description | safeHTML"
              ></label>
              <label class="head">{{ field.label }}</label>
              <input
                (ngModelChange)="onQuestionChange()"
[(ngModel)]="field.value"
                #emailInput="ngModel"
                email
                required
                style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                "
                class="form-control my-3"
                placeholder="{{ field.valueLabel }}"
                type="email"
              />
              <div
                style="color: red; font-size: 12px"
                *ngIf="
                  emailInput.invalid &&
                  (emailInput.dirty || emailInput.touched)
                "
              >
                <div
                  *ngIf="
                    emailInput?.errors != null
                      ? emailInput.errors!['required']
                      : false
                  "
                >
                  {{ "Email is required" | translator }}
                </div>
                <div
                  *ngIf="
                    emailInput?.errors != null
                      ? emailInput.errors!['email']
                      : false
                  "
                >
                  {{ "Please enter a valid email address" | translator }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <!-- content 2 END -->

      <!-- content 3 up-btn -->
      <div class="flex-column 2222" *ngSwitchCase="'SINGLE_ROW_TEXT'">
        <div class="">
          <div class="flex-column">
            <div
              class="flex-column"
              *ngFor="let field of currentQuestion.meta.fields"
            >
              <label
                class="description"
                *ngIf="currentQuestion.meta.description"
                [innerHTML]="currentQuestion.meta.description | safeHTML"
              ></label>
              <label class="head vvvvvvvvv">{{ field.label }}</label>
              <input
                (ngModelChange)="onQuestionChange()"
[(ngModel)]="field.value"
                style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                "
                class="form-control my-3"
                placeholder="{{ field.valueLabel }}"
                type="text"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- content 3 up-btn END -->

      <!-- content 4 select option -->
      <div *ngSwitchCase="'SELECT_ONE'">
        <div class="flex-column 3333">
          <div class="flex-column">
            <div class="flex-column">
              <label
                class="description"
                *ngIf="currentQuestion.meta.description"
                [innerHTML]="currentQuestion.meta.description | safeHTML"
              ></label>
              <label class="head">{{
                currentQuestion.questionText
              }}</label>
              <div
                class="flex flex-column gap-3 my-2"
                *ngFor="let field of currentQuestion.meta.fields"
              >
                <div class="field-checkbox 111">
                  <p-radioButton
                    [value]="field.label"
                    (ngModelChange)="onQuestionChange()"
[(ngModel)]="currentQuestion.meta.value"
                  ></p-radioButton>
                  <label class="mx-2 p-color">{{ field.label }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- content 4 select option END -->

      <!-- Dropdown Question -->
      <div *ngSwitchCase="'DROPDOWN_MENU'">
        <div class="4444">
          <label
            class="description mb-3"
            *ngIf="currentQuestion.meta.description"
            [innerHTML]="currentQuestion.meta.description | safeHTML"
          ></label>
          <label for="dd" class="head">{{
            currentQuestion.questionText
          }}</label>
          <p-dropdown
            styleClass="w-100 border"
            appendTo="body"
            name="dd"
            placeholder="{{ 'Select an option' | translator }}"
            (ngModelChange)="onQuestionChange()"
[(ngModel)]="currentQuestion.meta.value"
            [options]="currentQuestion.meta.fields"
            optionValue="label"
            optionLabel="label"
          >
          </p-dropdown>
        </div>
      </div>
      <!-- Dropdown Question end -->

      <div *ngSwitchCase="'SELECT_MANY'">
        <div class="flex-column 5555">
          <div class="flex-column">
            <div class="flex-column px-2">
              <label
                class="description"
                *ngIf="currentQuestion.meta.description"
                [innerHTML]="currentQuestion.meta.description | safeHTML"
              ></label>
              <label class="head">{{
                currentQuestion.questionText
              }}</label>
              <div
                class="flex flex-column gap-3 my-2"
                *ngFor="let field of currentQuestion.meta.fields"
              >
                <div class="field-checkbox 222">
                  <p-checkbox
                    [value]="field.label"
                    name="{{ currentQuestion.questionText }}"
                    (ngModelChange)="onQuestionChange()"
[(ngModel)]="currentQuestion.meta.value"
                  ></p-checkbox>
                  <label class="mx-2 p-color">{{ field.label }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex-column 6666" *ngSwitchCase="'CONTACT_INFO'">
        <div class="flex-column">
          <label
            class="description"
            *ngIf="currentQuestion.meta.description"
            [innerHTML]="currentQuestion.meta.description | safeHTML"
          ></label>
          <label class="head">{{ currentQuestion.questionText }}</label>
          <div
            class="flex-column"
            *ngFor="let field of currentQuestion.meta.fields"
          >
            <input
              (ngModelChange)="onQuestionChange()"
[(ngModel)]="field.value"
              placeholder="{{ field.label }}"
              style="
                background-color: transparent;
                border: none;
                border-bottom: solid 1px lightgrey;
                border-radius: 0px;
                width: 100%;
              "
              (keypress)="
                field.placeholder != 'رقم الهاتف'
                  ? true
                  : numberOnly($event)
              "
              class="form-control my-3"
              type="text"
            />
          </div>
        </div>
      </div>
      <div *ngSwitchCase="'COMMENT_BOX'">
        <div class="box-view">
          <div
            class="flex-column"
            *ngFor="let field of currentQuestion.meta.fields"
          >
            <label
              class="description mb-3"
              *ngIf="currentQuestion.meta.description"
              [innerHTML]="currentQuestion.meta.description | safeHTML"
            ></label>
            <label class="head">{{ field.label }}</label>
            <textarea
              class="radous-4px"
              (ngModelChange)="onQuestionChange()"
[(ngModel)]="field.value"
              rows="4"
              cols="30"
              pInputTextarea
            ></textarea>
          </div>
        </div>
      </div>

      <ng-container *ngSwitchCase="'SELECT_ONE_IMAGE'">
        <!-- select images -->
        <div>
          <label
            class="description"
            *ngIf="currentQuestion.meta.description"
            [innerHTML]="currentQuestion.meta.description | safeHTML"
          ></label>
          <div class="my-3">
            <span class="heading">
              {{ currentQuestion.questionText }}
            </span>
          </div>
          <div class="row py-3">
            <div
              class="col-12 col-md-6 p-2 my-2"
              *ngFor="let field of currentQuestion.meta.fields"
            >
              <div
                (click)="currentQuestion.meta.value = field.label"
                class="m-2 {{
                  currentQuestion.meta.value == field.label
                    ? 'img-select-active'
                    : 'img-select'
                }} "
              >
                <img
                  class="select-width"
                  src="{{ staticFileUrl + field.url }}"
                />
                <span class="w-200px-icon v4-color-white my-2 px-3">{{
                  field.label
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- select images END -->
      </ng-container>
      <ng-container *ngSwitchCase="'SELECT_MANY_IMAGE'">
        <!-- select multiple images -->
        <div>
          <label
            class="description"
            *ngIf="currentQuestion.meta.description"
            [innerHTML]="currentQuestion.meta.description | safeHTML"
          ></label>
          <div class="my-3">
            <span class="heading">
              {{ currentQuestion.questionText }}
            </span>
          </div>
          <div class="row py-3">
            <div
              class="col-12 col-md-6 p-2 my-2"
              *ngFor="
                let field of currentQuestion.meta.fields;
                let fieldIndex = index
              "
            >
              <div
                (click)="
                  addOrRemoveImageFromList(currentQuestion, field.label)
                "
                class="m-2 {{
                  currentQuestion.meta.value.includes(field.label)
                    ? 'img-select-active'
                    : 'img-select'
                }}"
              >
                <img
                  class="select-width"
                  src="{{ staticFileUrl + field.url }}"
                />
                <span class="w-200px-icon v4-color-white my-2 px-3">{{
                  field.label
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- select multiple images END -->
      </ng-container>
      <ng-container *ngSwitchCase="'STAR_RATING'">
        <!-- star Rating -->
        <div class="py-5">
          <label
            class="description"
            *ngIf="currentQuestion.meta.description"
            [innerHTML]="currentQuestion.meta.description | safeHTML"
          ></label>
          <div class="my-3">
            <span class="heading">
              {{ currentQuestion.questionText }}
            </span>
          </div>
          <div
            class="d-flex flex-wrap my-2"
            *ngFor="let field of currentQuestion.meta.fields"
          >
            <span class="w-200px">{{ field.label }}</span>
            <p-rating
              class="v4-ratting"
              (ngModelChange)="onQuestionChange()"
[(ngModel)]="field.value"
              [cancel]="false"
            ></p-rating>
          </div>
        </div>
        <!-- star Rating End -->
      </ng-container>
      <ng-container *ngSwitchCase="'SMILE_RATING'">
        <!-- smiley Rating -->
        <div class="py-5">
          <label
            class="description"
            *ngIf="currentQuestion.meta.description"
            [innerHTML]="currentQuestion.meta.description | safeHTML"
          ></label>
          <div class="my-3">
            <span class="heading">
              {{ currentQuestion.questionText }}
            </span>
          </div>
          <div class="d-flex flex-wrap py-3">
            <div
              (click)="currentQuestion.meta.value = field.label"
              class="{{
                currentQuestion.meta.value == field.label
                  ? 'rating-box-active'
                  : 'rating-box'
              }} m-2"
              *ngFor="let field of currentQuestion.meta.fields"
            >
              <img
                class="rating-width"
                src="{{ field.image }}"
                alt="loading"
              />
              <span class="clr-blackk my-2">{{ field.label }}</span>
            </div>
          </div>
        </div>
        <!-- smiley Rating End -->
      </ng-container>
      <ng-container *ngSwitchCase="'MULTI_POINT_SCALE'">
        <!-- row section -->
        <div class="py-5">
          <label
            class="description"
            *ngIf="currentQuestion.meta.description"
            [innerHTML]="currentQuestion.meta.description | safeHTML"
          ></label>
          <div class="my-3">
            <span class="heading">
              {{ currentQuestion.questionText }}
            </span>
          </div>
          <div class="row col-12">
            <!-- col-1 col-2 section -->
            <div class="col-md-2 col-12"></div>
            <ng-container
              *ngFor="let column of currentQuestion.meta.columns"
            >
              <div class="col d-flex justify-content-center my-1">
                <span class="w-200px-icon">{{ column }}</span>
              </div>
            </ng-container>
          </div>
          <div
            class="row col-12"
            *ngFor="let field of currentQuestion.meta.fields"
          >
            <div class="col-md-2 col-12 my-1">
              <span class="w-200px-icon">{{ field.field.label }}</span>
            </div>
            <div
              class="col"
              *ngFor="let col of currentQuestion.meta.columns"
            >
              <div
                style="cursor: pointer"
                (click)="field.field.value = col"
                class="radio-bg d-flex justify-content-center my-1"
              >
                <p-radioButton
                  [value]="col"
                  (ngModelChange)="onQuestionChange()"
[(ngModel)]="field.field.value"
                ></p-radioButton>
              </div>
            </div>
          </div>
        </div>
        <!-- row section END -->
      </ng-container>
      <ng-container *ngSwitchCase="'MULTI_SELECT_SCALE'">
        <!-- Multiple row section -->
        <div class="py-5">
          <label
            class="description"
            *ngIf="currentQuestion.meta.description"
            [innerHTML]="currentQuestion.meta.description | safeHTML"
          ></label>
          <div class="my-3">
            <span class="heading">
              {{ currentQuestion.questionText }}
            </span>
          </div>
          <div class="row col-12">
            <!-- col-1 col-2 section -->
            <div class="col-md-2 col-12"></div>
            <ng-container
              *ngFor="let column of currentQuestion.meta.columns"
            >
              <div class="col d-flex justify-content-center my-1">
                <span class="w-200px-icon">{{ column }}</span>
              </div>
            </ng-container>
          </div>
          <div
            class="row col-12"
            *ngFor="let field of currentQuestion.meta.fields"
          >
            <div class="col-md-2 col-12 my-1">
              <span class="w-200px-icon">{{ field.field.label }}</span>
            </div>
            <div
              class="col"
              *ngFor="let col of currentQuestion.meta.columns"
            >
              <div
                style="cursor: pointer"
                (mousedown)="addRemoveValueInFieldArray(field, col)"
                class="radio-bg d-flex justify-content-center my-1"
              >
                <p-checkbox
                  name="{{ field.field.label }}"
                  [value]="col"
[(ngModel)]="field.value"
                  (ngModelChange)="addRemoveValueInFieldArray(field, col); onQuestionChange();"
                ></p-checkbox>
              </div>
            </div>
          </div>
        </div>
        <!-- Multiple row section END -->
      </ng-container>
      <ng-container *ngSwitchCase="'RANK_ORDER'">
        <!-- DropDown section -->
        <div class="py-5">
          <label
            class="description"
            *ngIf="currentQuestion.meta.description"
            [innerHTML]="currentQuestion.meta.description | safeHTML"
          ></label>
          <div class="my-3">
            <span class="heading">
              {{ currentQuestion.questionText }}
            </span>
          </div>
          <div
            class="d-flex flex-wrap my-3"
            *ngFor="
              let field of currentQuestion.meta.fields;
              let i = index
            "
          >
            <div
              class="w-200pixel d-flex justify-content-start align-items-center"
            >
              <span class="w-200px-icon">{{ field.label }}</span>
            </div>
            <div class="brdr-btm mx-2 w-200pixel">
              <span class="w-100">
                <p-dropdown
                  appendTo="body"
                  (ngModelChange)="
                    getRankDDValues(field, $event, currentQuestion.meta); onQuestionChange()"
[(ngModel)]="field.value"
                  [options]="getRankDDValues2(currentQuestion)"
                  placeholder="-Select-"
                ></p-dropdown>
              </span>
            </div>
          </div>
        </div>
        <!-- DropDown section END -->
      </ng-container>
      <ng-container *ngSwitchCase="'DRAG_DROP'">
        <!-- drag drop section -->
        <div class="py-5">
          <label
            class="description"
            *ngIf="currentQuestion.meta.description"
            [innerHTML]="currentQuestion.meta.description | safeHTML"
          ></label>
          <div class="my-3">
            <span class="heading">
              {{ currentQuestion.questionText }}
            </span>
          </div>
          <div class="d-flex">
            <div class="drop-ui">
              <div
                class="p-2 border-1 surface-border border-round w-15rem"
              >
                <ul class="list-nonee flex flex-column gap-2 p-0 m-0">
                  <li
                    style="cursor: grab"
                    *ngFor="let field of this.currentQuestion.meta.fields"
                    class="p-2 border-round drag-shaddow"
                    pDraggable
                    (onDragStart)="dragStart(field)"
                    (onDragEnd)="dragEnd()"
                  >
                    {{ field.label }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="drag-ui">
              <p
                class="text-center surface-border border-bottom-1 v4-color-white"
              >
                {{ "Drag your choices here to rank them" | translator }}
              </p>
              <div
                class="p-2 border-1 surface-border border-round w-15rem"
                pDroppable
                (onDrop)="drop(currentQuestion)"
              >
                <div class="d-flex justify-content-end my-3">
                  <span class="d-and-d-text"
                    >{{ currentQuestion.meta.topAnchor }}
                    <i class="pi pi-arrow-circle-up"></i
                  ></span>
                </div>
                <ul
                  class="list-nonee flex flex-column gap-2 p-0 m-0"
                  *ngIf="currentQuestion.meta.orderedFields"
                >
                  <p-table
                    class="tab-menu-bg"
                    [value]="currentQuestion.meta.orderedFields"
                  >
                    <ng-template
                      class="tab-menu-bg"
                      pTemplate="body"
                      let-product
                      let-index="rowIndex"
                    >
                      <tr [pReorderableRow]="index">
                        <td pReorderableRowHandle style="cursor: grab">
                          <span
                            pReorderableRowHandle
                            class="p-2 border-round drag-shaddow"
                            style="cursor: grab"
                          >
                            {{ product.label }}
                          </span>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </ul>
                <div class="d-flex justify-content-end my-3">
                  <span class="d-and-d-text"
                    >{{ currentQuestion.meta.bottomAnchor }}
                    <i class="pi pi-arrow-circle-down"></i
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- drag drop section END -->
      </ng-container>
      <ng-container *ngSwitchCase="'DATE_TIME'">
        <!-- Birthdate -->
        <div class="py-5">
          <label
            class="description"
            *ngIf="currentQuestion.meta.description"
            [innerHTML]="currentQuestion.meta.description | safeHTML"
          ></label>
          <div class="my-3">
            <span class="heading">
              {{ currentQuestion.questionText }}
            </span>
          </div>
          <div class="d-flex">
            <div class="my-3">
              <!-- <label for="day">Day:</label> -->
              <select
                (ngModelChange)="onQuestionChange()"
[(ngModel)]="currentQuestion.meta.value.day"
                id="day"
                name="day"
                class="dob-select m-1"
              >
                <option value="">{{ "Day" | translator }}</option>
                <!-- Add day options here -->
                <option *ngFor="let day of days" value="{{ day }}">
                  {{ day }}
                </option>
                <!-- Add more days as needed -->
              </select>

              <!-- <label for="month">Month:</label> -->
              <select
                (ngModelChange)="onQuestionChange()"
[(ngModel)]="currentQuestion.meta.value.month"
                id="month"
                name="month"
                class="dob-select m-1"
              >
                <option value="">{{ "Month" | translator }}</option>
                <!-- Add month options here -->
                <option *ngFor="let month of months" value="{{ month }}">
                  {{ month }}
                </option>
                <!-- Add more months as needed -->
              </select>

              <!-- <label for="year">Year:</label> -->
              <select
                (ngModelChange)="onQuestionChange()"
[(ngModel)]="currentQuestion.meta.value.year"
                id="year"
                name="year"
                class="dob-select m-1"
              >
                <option value="">{{ "Year" | translator }}</option>
                <!-- Add year options here, e.g., from 1900 to the current year -->
                <!-- Example: -->
                <option *ngFor="let year of years" value="{{ year }}">
                  {{ year }}
                </option>
                <!-- Add more years as needed -->
              </select>
            </div>
          </div>
        </div>
        <!-- Birthdate END -->
      </ng-container>
      <ng-container *ngSwitchCase="'CALENDAR'">
        <!-- calander -->
        <div class="py-5">
          <label
            class="description"
            *ngIf="currentQuestion.meta.description"
            [innerHTML]="currentQuestion.meta.description | safeHTML"
          ></label>
          <div class="my-3">
            <span class="heading">
              {{ currentQuestion.questionText }}
            </span>
          </div>
          <div class="d-flex">
            <div class="d-flex my-3">
              <p-calendar
                class="survy-calnder"
                dir="ltr"
                appendTo="body"
                (ngModelChange)="onQuestionChange()"
[(ngModel)]="currentQuestion.meta.value"
                [showIcon]="true"
              ></p-calendar>
            </div>
          </div>
        </div>
        <!-- calander END -->
      </ng-container>
      <ng-container *ngSwitchCase="'PRESENTATION_TEXT'">
        <!-- descriptive -->
        <div class="">
          <div class="my-3">
            <span class="heading">
              {{ currentQuestion.questionText }}
            </span>
          </div>
        </div>
        <!-- descriptive END -->
      </ng-container>
      <ng-container *ngSwitchCase="'SECTION_HEADING'">
        <!-- descriptive full width bg purple -->
        <div class="">
          <div class="w-100 my-3">
            <div class="full-heading w-100">
              {{ currentQuestion.questionText }}
            </div>
          </div>
        </div>
        <!-- descriptive END -->
      </ng-container>
      <ng-container *ngSwitchCase="'SECTION_SUB_HEADING'">
        <!-- descriptive -->
        <div class="">
          <div class="my-3">
            <span class="heading">
              {{ currentQuestion.questionText }}
            </span>
          </div>
        </div>
        <!-- descriptive END -->
      </ng-container>
      <ng-container *ngSwitchCase="'IMPACT_MEASUREMENT'">
        <!-- star Rating -->
        <div class="py-5">
          <label
            class="description"
            *ngIf="currentQuestion.meta.description"
            [innerHTML]="currentQuestion.meta.description | safeHTML"
          ></label>
          <div class="my-3">
            <span class="heading">
              {{ currentQuestion.questionText }}
            </span>
          </div>
          <div class="my-3">
            <label
              class="description"
              *ngIf="currentQuestion.meta.correctAnswer"
              [innerHTML]="currentQuestion.meta.correctAnswer | safeHTML"
            ></label>
          </div>
          <div class="box-view">
            <div class="flex-column">
              <label class="head">{{
                "Employee Answer" | translator
              }}</label>
              <textarea
                class="radous-4px"
                (ngModelChange)="onQuestionChange()"
[(ngModel)]="currentQuestion.meta.empAnswer"
                rows="4"
                cols="30"
                pInputTextarea
              ></textarea>
            </div>
          </div>
          <div
            class="d-flex flex-wrap my-2"
            *ngFor="let field of currentQuestion.meta.fields"
          >
            <span class="w-200px">{{ field.label }}</span>
            <p-rating
              class="v4-ratting"
              (ngModelChange)="onQuestionChange()"
[(ngModel)]="field.value"
              [cancel]="false"
            ></p-rating>
          </div>
          <div class="box-view">
            <div class="flex-column">
              <label class="head">{{ "Comments" | translator }}</label>
              <textarea
                class="radous-4px"
                (ngModelChange)="onQuestionChange()"
[(ngModel)]="currentQuestion.meta.comment"
                rows="4"
                cols="30"
                pInputTextarea
              ></textarea>
            </div>
          </div>
        </div>
        <!-- star Rating End -->
      </ng-container>
    </div>
  </ng-container>